import React from "react";
import { ReCaptchaInstance } from "recaptcha-v3";

export const recaptchaContext = React.createContext<{
  recaptcha: null | ReCaptchaInstance;
}>({ recaptcha: null });
